import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getAttributeOrThrow, qsRequired } from '@/scripts/core/global'
import { type CartDrawer } from '@/scripts/cart/cart-drawer'
import { type uCoastWindow } from '@/scripts/setup'
declare let window: uCoastWindow
export class PromoBar extends UcoastEl {
	static htmlSelector = 'promo-bar'
	cartDrawer: CartDrawer
	cartDrawerSectionId: string
	cartAction: string
	variantId: string
	freeItemKey?: string
	constructor() {
		super()
		this.cartDrawer = qsRequired('cart-drawer')
		this.cartDrawerSectionId = getAttributeOrThrow('data-uc-cart-drawer-section-id', this)

		this.cartAction = getAttributeOrThrow('data-uc-promo-bar-cart-action', this)
		this.variantId = getAttributeOrThrow('data-uc-promo-bar-variant-id', this)
		const freeItemKey = this.getAttribute('data-uc-promo-bar-free-item-key')
		console.log({freeItemKey})
		this.freeItemKey = freeItemKey ?? undefined
	}

	override connectedCallback() {
		if (this.cartAction === 'ADD' && this.variantId) {
			void this.addFreeItem()
		} else if (this.cartAction === 'REMOVE' && this.freeItemKey) {
			void this.removeFreeItem()
		}
	}

	async addFreeItem() {
		const response = await fetch(`${window.routes.cart_add_url}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: `application/json`,
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				sections: `${this.cartDrawerSectionId}`,
				items: [
					{
						quantity: 1,
						id: parseInt(this.variantId),
						properties: {
							_gwp_free: 'true',
						},
					},
				],
			}),
		})
			.then((response) => response.json())
			.then(async (response) => {
				if (response.status) {
					console.log('error', response.status)
				} else {
					if (this.cartDrawer && response.sections && this.cartDrawerSectionId) {
						const newDocument = new DOMParser().parseFromString(
							response.sections[this.cartDrawerSectionId],
							'text/html'
						)
						const newDrawer = newDocument.querySelector('cart-drawer')
						if (newDrawer) {
							this.cartDrawer.innerHTML = newDrawer.innerHTML
							this.cartDrawer.getOverlay().addEventListener('click', this.cartDrawer.close.bind(this.cartDrawer))
						}
					}
				}
			})
			.catch((e) => {
				console.error(e)
			})
		console.log('addFreeItem Response', response)
	}

	async removeFreeItem() {
		const cartJSON = await fetch('/cart.js').then((response) => response.json())
		const freeItems = cartJSON.items.filter(
			(item) => item?.properties?._gwp_free === 'true' && item.final_line_price === 0
		)
		/*if (freeItems.length > 0) {
		  console.log("NO DELETE, FREE ITEMS EXIST", cartJSON)
		  return;
		}*/
		const variantItemsMatch = cartJSON.items.filter(
			(item) => item.variant_id === parseInt(this.variantId)
		)
		if (variantItemsMatch.length < 1) {
			console.log('NO DELETE, NOTHING TO DELETE', cartJSON)
		}
		console.log('RUN DELETE', cartJSON)
		this.freeItemKey = variantItemsMatch[0].key
		const deleteQuantity = variantItemsMatch[0].quantity - 1

		fetch(`${window.routes.cart_change_url}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: `application/json`,
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				sections: `${this.cartDrawerSectionId}`,
				id: this.freeItemKey,
				quantity: deleteQuantity,
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					console.log('error', response.status)
				} else {
					if (this.cartDrawer && response.sections && this.cartDrawerSectionId) {
						const newDocument = new DOMParser().parseFromString(
							response.sections[this.cartDrawerSectionId],
							'text/html'
						)
						const newDrawer = newDocument.querySelector('cart-drawer')
						if (newDrawer) {
							this.cartDrawer.innerHTML = newDrawer.innerHTML
						}
					}
				}
			})
			.catch((e) => {
				console.error(e)
			})
	}
}
